/**
 * Created by lihanying on 2017/7/17.
 */
import React from 'react'
import { Table, Button, message } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import ModalDetail from './modalDetail'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      type: '-1',
    }
  }

  handleOk = (item) => {
    //修改
    if (item.name) {
      if (this.state.type === '1') {
        this.props.fetchSetCommodityType('UpdateCommodityType', item) //修改
      } else {
        this.props.fetchSetCommodityType('AddCommodityType', item) //添加
      }
      this.setState({ visible: false })
    } else {
      message.info('请输入分类名称')
    }
  }

  handleCancel = () => {
    this.setState({ visible: false })
  }

  render() {
    const { list, commodityType } = this.props
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '分类名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '是否为原材料',
        dataIndex: 'is_materials',
        key: 'is_materials',
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div>
              <Button
                type="primary"
                style={{ marginRight: '10px' }}
                onClick={() => {
                  this.setState({ visible: true, record: record, type: '1' })
                }}
              >
                修改
              </Button>
              <Popconfirm
                title={`你确认要删除${record.name}商品吗?`}
                okText="确认"
                cancelText="取消"
                onConfirm={() =>
                  this.props.fetchSetCommodityType('DelCommodityType', {
                    id: record.id,
                  })
                }
              >
                <Button type="primary" danger>
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]

    const data = list.map((item) => {
      if (item.materials === '1') {
        item.is_materials = '是'
      } else {
        item.is_materials = '否'
      }
      return item
    })

    return (
      <div>
        <Button
          type="primary"
          onClick={() =>
            this.setState({ visible: true, type: '-1', record: {} })
          }
        >
          添加分类
        </Button>
        <Table rowKey="id" bordered columns={columns} dataSource={data} />

        {this.state.visible && (
          <ModalDetail
            {...this.state}
            commodityType={commodityType}
            handleOk={this.handleOk}
            handleCancel={this.handleCancel}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodityType/component/commodityTypeList.js